/**
 * @fileoverview API layer for the derived org chart. All endpoint knowledge for
 * this feature lives here; components call these named functions and never
 * assemble URLs themselves.
 */
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";

const COMPANY = config.POSTLOGIN_API_URL_COMPANY;

/** @returns {Promise} financial years for the org-chart filter. */
export const getFinancialYears = () =>
  apiCall(`${COMPANY}getFinancialYear`, {}, {}, "GET");

/** @returns {Promise} locations (sources) for the org-chart filter. */
export const getLocations = () =>
  apiCall(`${COMPANY}getSource`, {}, {}, "GET");

/**
 * Derived org chart for one financial year + location. Resolves to
 * `{ tree, deactivated }` — the nested tree plus the in-scope role holders
 * hidden from it, served together so the page costs one request.
 * @param {number|string} financialYearId
 * @param {number|string} locationId
 * @returns {Promise}
 */
export const getOrgChart = (financialYearId, locationId) =>
  apiCall(`${COMPANY}orgChart`, {}, { financialYearId, locationId }, "GET");
